import { Route, Redirect } from "react-router-dom"

export const PrivateRoute = ({ component: Component,language, ...rest }) => (
    <Route {...rest} render={(props) => (
        localStorage.getItem('accessToken')
            ? <Component {...props} language={language}/>
            : <Redirect to={{
                pathname: `signIn`,
                state: { from: props.location }
            }} />
    )} />
)